
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/services",
      function () {
        return require("private-next-pages/preview/services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/services"])
      });
    }
  